import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import { FormikNumberInput } from '../../../../components/InputNumberValidation/FormikNumberInput';
import LoadingEllipsis from '../../../../components/LoadingEllipsis/LoadingEllipsis';
import { categoryOptions, formatUnityMesasurementCategory } from '../../../../utils/functionsFormatPatterns/functionFormatDiet'
import { MdCreate } from 'react-icons/md';
import SelectSearch from './SelectSearch'
import '../styles/CreateUnityMeasurement.css';

function CreateUnityMeasurements({ type = {}, onSave, onCancel }) {
  const [errors, setErrors] = useState({});
  const icoUpdate = <MdCreate className='icon' />;
  const [customCategory, setCustomCategory] = useState('');
  const [categoryOpts, setCategoryOpts] = useState(categoryOptions);

  useEffect(() => {
    if (
      type.category &&
      !categoryOptions.find(opt => opt.value === type.category)
    ) {
      // adiciona a categoria personalizada à lista local
      setCategoryOpts(prev => [
        ...prev,
        { value: type.category, label: formatUnityMesasurementCategory(type.category) }
      ]);
      setCustomCategory(type.category);
    }
  }, [type.category]);


  const initialValues = {
    unit_name: type.unit_name || '',
    unit_abbreviation: type.unit_abbreviation || '',
    equivalent_value: type.equivalent_value || '',
    favorite_item: type.favorite_item || '',
    category: type.category || '',
  };

  const validationSchema = Yup.object({
    unit_name: Yup.string().required('Nome da unidade é obrigatório'),
    unit_abbreviation: Yup.string().required('Abreviação é obrigatória'),
    equivalent_value: Yup.number()
      .required('Valor equivalente é obrigatório')
      .positive('Deve ser um valor positivo'),
    category: Yup.string().required('Categoria é obrigatória'),
  });

  const handleSubmit = async (values) => {
    const categoryFinal = values.category === 'custom' ? customCategory.trim() : values.category;

    await onSave({
      ...type,
      ...values,
      category: categoryFinal,
      equivalent_value: parseFloat(values.equivalent_value).toFixed(2),
      favorite_item: values.favorite_item ? 1 : 0,
    });
  };




  return (
    <div className='boxUnityMeasurements_Main'>
      <h3>{type?.unit_measurement_id ? 'Editar Unidade de Medida' : 'Nova Unidade de Medida'}</h3>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleSubmit(values).finally(() => setSubmitting(false));
        }}
      >
        {({ isSubmitting }) => (
          <>
            <Form>
              <div className="boxUnityMeasurements">
                <h5>Unidades de Medida</h5>
                <div className="unityMeasurement_form_group">
                  <label htmlFor="unit_name">Nome da Unidade:</label>
                  <Field type="text" name="unit_name" />
                  <ErrorMessage name="unit_name" component="div" className="error-message" />
                </div>

                <div className="unityMeasurement_form_group">
                  <label htmlFor="unit_abbreviation">Abreviação:</label>
                  <Field type="text" name="unit_abbreviation" />
                  <ErrorMessage name="unit_abbreviation" component="div" className="error-message" />
                </div>

                <FormikNumberInput
                  name="equivalent_value"
                  label="Valor Equivalente:"
                  maxInteger={6}
                  maxDecimal={2}
                  maxValue={100000}
                  className="unityMeasurement_form_group"
                />

                <div className="unityMeasurement_form_group">
                  <label htmlFor="favorite_item">É item favorito?</label>
                  <div className="toggle-switch">

                    <Field name="favorite_item">
                      {({ field }) => (
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={field.value === 1}
                            onChange={() => field.onChange({ target: { name: field.name, value: field.value === 1 ? 0 : 1 } })}
                          />
                          <span className="slider round"></span>
                        </label>
                      )}
                    </Field>
                  </div>
                </div>

                <div className="unityMeasurement_form_group">
                  <label htmlFor="categroy">Categoria:</label>
                  <Field name="category">
                    {({ field }) => (
                      <>
                        <SelectSearch
                          name="category"
                          options={categoryOpts}
                          classNamePrefix="custom-select"
                          value={categoryOpts.find(opt => opt.value === field.value)}
                          onChange={selected => field.onChange({ target: { name: field.name, value: selected.value } })}
                        />
                        {field.value === 'custom' && (
                          <div className="unityMeasurement_form_group">
                            <label htmlFor="customCategory">Informe a nova categoria:</label>
                            <input
                              type="text"
                              name="customCategory"
                              value={customCategory}
                              onChange={(e) => setCustomCategory(e.target.value)}
                              placeholder="Digite a nova categoria"
                            />
                          </div>
                        )}
                      </>
                    )}
                  </Field>
                </div>
              </div>
              <div className="form-actions">
                {isSubmitting ? (
                  <div className="boxUnityMeasurements_Buttons">
                    <LoadingEllipsis message={<>Enviando {icoUpdate}</>} />
                  </div>
                ) : (
                  <div className="boxUnityMeasurements_Buttons">
                    <button className="sendBtn" type="submit">
                      {type?.unit_measurement_id ? 'Atualizar' : 'Enviar'}
                    </button>
                    <button className="backBtn" type="button" onClick={onCancel}>
                      Voltar
                    </button>
                  </div>
                )}
              </div>
            </Form>
          </>
        )}
      </Formik>

    </div>
  );
}

export default CreateUnityMeasurements;
